import { Handle, Position } from '@xyflow/react';

interface EndNodeData extends Record<string, unknown> {
  label: string;
  type: 'end';
  outputVariables?: Record<string, unknown>;
}

interface EndNodeProps {
  data: EndNodeData;
  selected?: boolean;
}

export default function EndNode({ data, selected }: EndNodeProps) {
  return (
    <div
      style={{
        width: '64px',
        height: '64px',
        borderRadius: '50%',
        background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
        border: selected ? '3px solid #b91c1c' : '2px solid #ef4444',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        fontSize: '12px',
        fontWeight: 'bold',
        boxShadow: selected
          ? '0 0 0 4px rgba(239, 68, 68, 0.3), 0 4px 12px rgba(0, 0, 0, 0.15)'
          : '0 4px 12px rgba(0, 0, 0, 0.15)',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
      }}
    >
      <span style={{ textAlign: 'center', padding: '4px' }}>{data.label}</span>
      <Handle
        type="target"
        position={Position.Top}
        style={{
          width: '12px',
          height: '12px',
          background: '#ef4444',
          border: '2px solid white',
        }}
      />
    </div>
  );
}
